import * as log from '../../util/log';
import { storableError } from '../../util/errors';
import { updateUserTypeCandidate, getFileUserCandidateType } from '../../util/api';
import { login } from '../../ducks/auth.duck';

export const signup = params => (dispatch, getState, sdk) => {
  return sdk.currentUser
    .create(params)
    .then(async resp => {
      await dispatch(login(params.email, params.password))
      return resp;
    })
    .catch(err => {
      const e = storableError(err);
      log.error(err, 'signup-failed', {
        email: params.email,
        firstName: params.firstName,
        lastName: params.lastName,
      });
      throw e;
    });
};

export const getParentInfo = id => (dispatch, getState, sdk) => {;
  return sdk.users
    .show({ id })
    .then(resp => {
      return resp;
    })
    .catch(e => {
      log.error(e, 'get-parent-info-failed');
    });
};

const createAccountToken = (stripePublishableKey) => {
  if (typeof window === 'undefined' || !window.Stripe) {
    throw new Error('Stripe must be loaded for submitting PayoutPreferences');
  }
  const accountInfo = {
    business_type: 'non_profit',
    tos_shown_and_accepted: true,
  };
  const stripe = window.Stripe(stripePublishableKey);

  return stripe
    .createToken('account', accountInfo)
    .then(response => {
      return response.token.id;
    })
    .catch(err => {
      const e = storableError(err);
      const stripeMessage =
        e.apiErrors && e.apiErrors.length > 0 && e.apiErrors[0].meta
          ? e.apiErrors[0].meta.stripeMessage
          : null;
      log.error(err, 'create-stripe-account-failed', { stripeMessage });
      throw e;
    });
}

const createStripeAccount = (params, sdk) => {
  const {
    accountToken,
    bankAccountToken,
    businessProfileMCC,
    businessProfileURL,
  } = params;
  const requestedCapabilities = ['card_payments', 'transfers'];

  return sdk.stripeAccount.create(
    {
      country: 'FR',
      accountToken,
      bankAccountToken,
      requestedCapabilities,
      businessProfileMCC,
      businessProfileURL,
    },
    { expand: true }
  ).then((res) => {
    const stripeAccount = res.data.data;
    return stripeAccount;
  })
  .catch(err => {
    const e = storableError(err);
    const stripeMessage =
      e.apiErrors && e.apiErrors.length > 0 && e.apiErrors[0].meta
        ? e.apiErrors[0].meta.stripeMessage
        : null;
    log.error(err, 'create-stripe-account-failed', { stripeMessage });
    throw e;
  });
};

export const updateUserToCandidate = params => async (dispatch, getState, sdk) => {
  const accountToken = await createAccountToken(params.stripePublishableKey);
  const stripeAccount = await createStripeAccount({
    accountToken: accountToken,
    bankAccountToken: params.bankAccountToken,
    businessProfileMCC: params.businessProfileMCC,
    businessProfileURL: params.businessProfileURL
  }, sdk);

  const data = new FormData();
  data.append('stripeAccountId', stripeAccount.attributes.stripeAccountId);
  data.append('isId', params.isId);
  data.append('legalName', params.legalName);
  data.append('birthDate', params.birthDate.format('DD-MM-YYYY'));
  data.append('proofAddressFile', params.proofAddressFile);
  data.append('personalAddress', params.personalAddress);
  data.append('personalCity', params.personalCity);
  data.append('personalPhone', params.personalPhone);
  data.append('personalZip', params.personalZip);
  data.append('bankIdentityFile', params.bankIdentityFile);

  if (params.isId) {
    data.append('colorFrontCardFile', params.colorFrontCardFile);
    data.append('colorBackCardFile', params.colorBackCardFile);
  } else {
    data.append('imageYourPassportFile', params.imageYourPassportFile);
  }

  if (!params.hasParent) {
    data.append('associationLegalName', params.associationLegalName);
    data.append('JOAFFile', params.JOAFFile);
  }

  if (params.personalSecondAddress) {
    data.append('personalSecondAddress', params.personalSecondAddress);
  }

  return updateUserTypeCandidate(data);
};

export const getFiles = () => getFileUserCandidateType().then(({ data }) => data).catch(err => {
  const e = storableError(err);
  throw e;
});;
